import React from 'react';
import { faChartColumn } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonText } from '@morressier/alembic';

interface AnalyticsDashboardProps {
  publisherId?: string;
}

const AnalyticsDashboard: React.FC<AnalyticsDashboardProps> = ({
  publisherId
}) => {
  const handleViewAnalyticsDashboard = (): void => {
    const dashboardUrl = publisherId
      ? `/dashboard?publisherId=${publisherId}&tab=overview`
      : '/dashboard?tab=overview';
    window.open(dashboardUrl, '_blank');
  };

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '8px',
        margin: '16px 0 8px 0'
      }}
    >
      <ButtonText
        onClick={handleViewAnalyticsDashboard}
        leftIcon={<FontAwesomeIcon icon={faChartColumn} />}
      >
        Analytics & Insights
      </ButtonText>
    </div>
  );
};

export default AnalyticsDashboard;
